import { render, staticRenderFns } from "./folder-move-dropdown.vue?vue&type=template&id=4aa9113e"
import script from "./folder-move-dropdown.vue?vue&type=script&lang=js"
export * from "./folder-move-dropdown.vue?vue&type=script&lang=js"
import style0 from "./folder-move-dropdown.vue?vue&type=style&index=0&id=4aa9113e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports